import Vue from 'vue';
import App from './App.vue';
import router from './router';

import { Button, Cell, Icon, Form, Field, CellGroup, Switch, NavBar, Toast, Loading, Dialog, SwipeCell, List, PullRefresh, Popup, DatetimePicker } from 'vant';

import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';

Vue.use(Button);
Vue.use(Cell);
Vue.use(Icon);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Switch);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(SwipeCell);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Popup);
Vue.use(DatetimePicker);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
